import React from 'react'

const MySvgIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      fill='none'
      version='1.1'
      width='20'
      height='20'
      viewBox='0 0 20 20'
    >
      <defs>
        <clipPath id='master_svg0_70_5896'>
          <rect x='0' y='0' width='20' height='20' rx='0' />
        </clipPath>
      </defs>
      <g clipPath='url(#master_svg0_70_5896)'>
        <g>
          <path
            d='M6.16156,7.52923C7.37074,7.52923,8.52006,7.52923,9.66846,7.52923C10.4356,7.52923,11.20365,7.54114,11.96987,7.52282C12.28299,7.5155,12.41099,7.60066,12.40086,7.93123C12.38152,8.541080000000001,12.38152,9.15277,12.40915,9.76171C12.42757,10.17103,12.3014,10.32121,11.8658,10.3148C10.1013,10.29007,8.3368,10.30106,6.572290000000001,10.30106C6.45349,10.30106,6.3337699999999995,10.31388,6.16524,10.32304C6.16524,10.71954,6.16524,11.0959,6.16524,11.4722C6.16524,13.2725,6.15419,15.0728,6.1735299999999995,16.8731C6.1781299999999995,17.2741,6.05933,17.3996,5.65228,17.3831C4.91738,17.3547,4.17971,17.3703,3.4448090000000002,17.3968C3.138139,17.4078,3.0230229,17.287,3.0202601,17.0077C3.012893,16.337400000000002,3,15.6662,3,14.995C3.000920931,10.58585,3.00552559,6.17582,3.00920931,1.766716C3.00920931,0.9178598,2.9742139,1.00118906,3.775424,1.00302086C7.94908,1.0103466,12.12274,1.00943144,16.2964,1.0121784C16.984299999999998,1.0121784,16.988,1.0130936,16.993499999999997,1.713607C16.9982,2.23189,16.9714,2.7520100000000003,16.9982,3.26939C17.0184,3.67046,16.8738,3.79592,16.4705,3.79317C13.9388,3.77852,11.40718,3.78676,8.87462,3.78584C8.09183,3.78584,7.30996,3.78401,6.52717,3.7776C6.328250000000001,3.77577,6.15787,3.77211,6.158799999999999,4.04773C6.16432,5.1887,6.16064,6.32967,6.16064,7.52832L6.16156,7.52923Z'
            fill='#333333'
            fillOpacity='1'
          />
        </g>
      </g>
    </svg>
  )
}

export default MySvgIcon
